import React from 'react'
import ReactDatePicker from 'react-datepicker'
import classNames from 'classnames'
import { CalendarProps } from './DatePicker.types'
import styles from './DatePicker.module.scss'

const Calendar = React.forwardRef<HTMLInputElement, CalendarProps>((props, ref) => {
  const { tabIndex } = props

  return (
    <div className={classNames(styles.wrapper, styles.calendar)} ref={ref} tabIndex={tabIndex}>
      <ReactDatePicker
        inline
        formatWeekDay={(nameOfDay) => nameOfDay.substring(0, 1)}
        calendarStartDay={1}
        {...props}
      />
    </div>
  )
})

Calendar.displayName = 'Calendar'

export default Calendar
